<fdb-alert-message [header] = "'Keine Berechtigung!'"
[content] = "'Sie sind nicht berechtigt, diese Seite zu betreten.'"
[feed] = "'Bitte besorgen Sie sich die entsprechende Berechtigung und wiederholen den Aufruf.'"
[type]= "'danger'"></fdb-alert-message>
